import axios from 'axios';

const API_URL = 'https://manager.fablabsion.ch/';

export default axios.create({
  baseURL: API_URL
});
